export default __webpack_public_path__ + "static/media/reading.ec9c5814.svg";